import { useState, useEffect, useRef } from "react";

export function useProgressAnimation(normalTarget: number, specialTarget: number) {
  const [normalWidthState, setNormalWidthState] = useState(0);
  const [specialWidth, setSpecialWidth] = useState(0);
  const [showSpecial, setShowSpecial] = useState(false);

  const normalStart = useRef<number | null>(null);
  const specialStart = useRef<number | null>(null);
  const duration = 1000;

  useEffect(() => {
    normalStart.current = null;
    const step = (timestamp: number) => {
      if (!normalStart.current) normalStart.current = timestamp;
      const progress = timestamp - normalStart.current;
      const next = Math.min((progress / duration) * normalTarget, normalTarget);
      setNormalWidthState(next);
      if (next < normalTarget) requestAnimationFrame(step);
      else if (specialTarget > 0) setTimeout(() => setShowSpecial(true), 200);
    };
    requestAnimationFrame(step);
  }, [normalTarget, specialTarget]);

  useEffect(() => {
    if (!showSpecial || specialTarget <= 0) return;

    specialStart.current = null;
    const step = (timestamp: number) => {
      if (!specialStart.current) specialStart.current = timestamp;
      const progress = timestamp - specialStart.current;
      const next = Math.min((progress / duration) * specialTarget, specialTarget);
      setSpecialWidth(next);
      if (next < specialTarget) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [showSpecial, specialTarget]);

  return { normalWidthState, specialWidth, showSpecial };
}
